// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"z7qpL7rr7nlfIlOmvUHE","headerWrapper":"lMAfZd8y475yYN_BKKPq","contentWrapper":"ZT1HFku4knmgEVokgbIQ","footerWrapper":"S_7ng5cxr1nDX4uvr3H3"};